export default __webpack_public_path__ + "4402cc799ce04582b3a5f4c6aea850c0.png";